import { ItemDoc } from "@megaron/docs-contracts";
import { Order } from "@megaron/fulfillment-contracts";

import { OrderTile } from "./OrderTile";

type Props = {
  orders: Order[];
  itemDocs: ItemDoc[];
  isLoading?: boolean;
};

export const OrdersList: React.FC<Props> = ({ orders, itemDocs }) => {
  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.625rem", width: "100%", marginBottom: "1rem" }}>
      {orders.map((order) => (
        <OrderTile key={order.id} order={order} itemDocs={itemDocs} />
      ))}
    </div>
  );
};
